import Inputz from "../ui/atoms/Inputz";
import Buttonz from "../ui/atoms/Buttonz";
import TitleZ from "../ui/atoms/TitleZ";
import CountryDropDown from "../ui/atoms/DropDownzCountry";
import DropDownz from "../ui/atoms/DropDownz";
import TextAreaz from "../ui/atoms/TextAreaz";
import { useEffect, useState } from "react";
import "../styles/compo.scss";
import SocialMedia from "../ui/compoP/SocialMedia";
import ImageUploader from "../ui/atoms/ImageUploader";
import { useDispatch } from "react-redux";
import { signupSubmit } from "../auth/signupSubmit";
import AllPopups from "../ui/compoP/AllPopups";
import UserCard from "../ui/compoP/UserCard";
import SvgIcn from "../data/IconCompo";
import Switchz from "../ui/atoms/Switchz";
import { useParams } from "react-router-dom";
import LogoP from "../ui/atoms/LogoP";
import { getSignupRequest } from "../services/UserService";

function Signup() {
  const dispatch = useDispatch();
  const params = useParams();
  const [data, setData] = useState({});
  const [errors, setErrors] = useState({});
  const [timeLeft, setTimeLeft] = useState(null);
  const [visibleInputs, setVisibleInputs] = useState({
    figma: false,
    dribbble: false,
    behance: false,
    linkedin: false,
    x: false,
    instagram: false,
    facebook: false,
    tiktok: false,
  });
  const [socialOrder, setSocialOrder] = useState([]);

  useEffect(() => {
    const fetchSignupRequest = async () => {
      try {
        const response = await getSignupRequest(params.id);
        if (response?.data?.data) {
          const createdAt = new Date(response.data.data.createdAt);
          const expiryDate = new Date(
            createdAt.getTime() + 2 * 24 * 60 * 60 * 1000
          ); // 2 days in milliseconds

          const timer = setInterval(() => {
            const now = new Date();
            const difference = expiryDate - now;

            if (difference <= 0) {
              setTimeLeft("Expired");
              clearInterval(timer);
            } else {
              const days = Math.floor(difference / (1000 * 60 * 60 * 24));
              const hours = Math.floor(
                (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
              );
              const minutes = Math.floor(
                (difference % (1000 * 60 * 60)) / (1000 * 60)
              );
              const seconds = Math.floor((difference % (1000 * 60)) / 1000);

              setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s`);
            }
          }, 1000);

          return () => clearInterval(timer);
        }
      } catch (error) {
        console.error("Error fetching signup request:", error);
      }
    };

    fetchSignupRequest();
  }, [params.id]);

  useEffect(() => {
    setData((prev) => {
      return {
        signup_request_id: params.id,
        email: params.email,
        ...prev,
      };
    });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => {
      return { ...prev, [`${name}`]: "" };
    });
    console.log({
      ...data,
      [name]: value,
    });
  };

  const handleSubmit = async () => {
    const newErrors = await signupSubmit(dispatch, data, "en", visibleInputs);
    setErrors(newErrors);
  };

  return (
    <div className="signup-hero">

      <div className="signup-usercard-box">
        <UserCard
          data={data}
          visibleInputs={visibleInputs}
          socialOrder={socialOrder}
        />
      </div>

      <div className="signup-page-box">
        <div className="form-box">
          <LogoP
            logo="logo01"
            hoverLogo="logo03"
            logoTypeEn="logotype_en"
            logoTypeJp="logotype_jp"
            style={{ width: "72px" }}
            className="signup-logo"
          />
        </div>
        <div className="form-box">
          <TitleZ
            title="Signup"
            text={
              <>
                Complete the form below to sign up before your invitation expires. 
                {timeLeft && (
        <div>
        
          Time Remaining: <span>{timeLeft}</span>
        </div>
      )}
                  Please note that all fields are
                required.
              </>
            }
          />
        </div>
        <div className="form-box">
          <ImageUploader
            addIcon={<SvgIcn name={"error"} />}
            deleteIcon={<SvgIcn name={"error"} />}
            onChange={(value) => handleChange({ name: "image", value: value })}
            error={errors?.image}
            onDelete={() => {
              handleChange({ name: "image", value: undefined });
            }}
            className="avatar" // Pass error for profile image
          />
        </div>
        <div className="form-box">
          <Inputz
            iconL="mail"
            focusL="mail"
            iconR="lock"
            focusR="cal"
            hovericonR="mail"
            label="Email address"
            type="email"
            placeholder="Email address"
            name="email"
            value={data.email}
            disable={true}
            onChange={handleChange}
            error={errors?.email} // Pass error for email
          />
          <Inputz
            iconL="password"
            iconR="ok"
            focusR="cal"
            iconOn="eye_on"
            iconOff="eye_off"
            placeholder="Password"
            type="password"
            name="password"
            value={data.password}
            onChange={handleChange}
            error={errors?.password} // Pass error for password
          />
        </div>

        <div className="form-box">
          <div className="text-hint-box">
            Username can only include letters, numbers, and underscores. (max 16
            characters)
          </div>

          <Inputz
            iconL="username"
            label="Username"
            type="text"
            placeholder="Username"
            permanentPlaceholder="uud.io/"
            textCounter={16}
            usernameSlug={true}
            name="username"
            value={data.username}
            onChange={handleChange}
            error={errors?.username}
            className="username"
          />
          <Inputz
            iconL="user"
            label="Name"
            type="text"
            placeholder="Your Name"
            name="fullName"
            internationalName={true}
            textCounter={20}
            value={data.fullName}
            onChange={handleChange}
            error={errors?.fullName} // Pass error for full name
          />
          <CountryDropDown
            iconL="flag"
            focusL="cal"
            iconR="drop_down"
            iconRHover="drop_up"
            iconClear="clear"
            focusR="cal"
            hoverIconR="mail"
            placeholder="Your Laction"
            onSelect={(e) => {
              handleChange(e);
            }}
            value={data.nationality}
            name="nationality"
            error={errors?.nationality}
          />
          <DropDownz
            iconL="bag"
            focusL="bag"
            iconR="drop_down"
            iconRHover="drop_up"
            iconClear="clear"
            focusR="cal"
            hoverIconR="mail"
            placeholder="Your Role"
            className="custom-input"
            onSelect={handleChange}
            name="subRole"
            error={errors?.subRole} // Pass error for role
          >
            <span>UX Designer</span>
            <span>UI Designer</span>
            <span>Product Designer</span>
            <span>Motion Designer</span>
            <span>Graphic Designer</span>
            <span>Others - Designer</span>
            <span>Frontend Developer</span>
            <span>Backend Developer</span>
            <span>Full Stack Developer</span>
            <span>Manager</span>
            <span>Marketer</span>
            <span>Director</span>
            <span>Student</span>
            <span>Others - Tech</span>
          </DropDownz>
          <div className="experience-box">
            <p>Years of experience:</p>
            <Inputz
              iconL="cal"
              // focusL="mail"
              // label="Years of Experience"
              type="text"
              placeholder="0"
              name="experience"
              numbersOnly={true}
              value={data.experience || ""}
              onChange={handleChange}
              
              error={errors?.experience} // Pass error for experience
            />
          </div>
          <TextAreaz
            className="insider"
            title="Introduction"
            iconL="namecard"
            iconR="clear"
            value={data.intro || ""}
            maxLength={200}
            onChange={handleChange}
            name="intro"
            error={errors?.intro} // Pass error for introduction
          />
        </div>
        <div className="form-box">
          <SocialMedia
            iconOn="instagram_line"
            iconOff="instagram_line"
            data={data}
            handleChange={handleChange}
            visibleInputs={visibleInputs}
            setVisibleInputs={setVisibleInputs}
            errors={errors}
            setData={setData}
            socialOrder={socialOrder}
            setSocialOrder={setSocialOrder}
          />

          <div className="text-hint-box">
            Add your website, portfolio, and your personal content links.
          </div>

          <Inputz
            iconL="globe"
            focusL="mail"
            hovericonR="mail"
            label="Email address"
            type="email"
            placeholder="Personal Website / Profile"
            onChange={handleChange}
            value={data.personalSite}
            name="personalSite"
            error={errors?.personalSite}
          />

          <Inputz
            iconL="blog_line"
            focusL="mail"
            hovericonR="mail"
            label="Email address"
            type="email"
            placeholder="Personal Blog / Vlog / podcast"
            onChange={handleChange}
            value={data.personalBlog}
            name="personalBlog"
            error={errors?.personalBlog}
          />
        </div>

        <div className="form-box">
          <Switchz
            hintText={
              <div className="hint-text">
                By signing up, I agree to <a href="#">Terms & Privacy</a>.
              </div>
            }
            onText="Agree"
            offText="Agree?"
            width="100px"
            onIcon="ok"
            direction="row-reverse"
            className="SignupSwitch"
            name="terms"
            onToggle={handleChange}
            error={errors?.terms}
          />
        </div>
        <div className="form-box">
          <Buttonz
            iconR="login"
            hoverR="login"
            label="Signup"
            onClick={handleSubmit}
          />
        </div>

        <AllPopups />
      </div>
    </div>
  );
}

export default Signup;
